// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"a7965390","359":"01ee31ce"}[chunkId] + ".chunk.js";
};